/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllExecutionsAvailableByFacilityId200ResponseDataInner } from './FindAllExecutionsAvailableByFacilityId200ResponseDataInner';
import {
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSONTyped,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSONTyped,
} from './FindAllExecutionsAvailableByFacilityId200ResponseDataInner';

/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200Response
 */
export interface FindAllExecutionsAvailableByFacilityId200Response {
    /**
     * 
     */
    data?: Array<FindAllExecutionsAvailableByFacilityId200ResponseDataInner>;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200Response interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200Response(value: object): value is FindAllExecutionsAvailableByFacilityId200Response {
    return true;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200Response {
    return FindAllExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerFromJSON)),
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseToJSON(json: any): FindAllExecutionsAvailableByFacilityId200Response {
    return FindAllExecutionsAvailableByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseToJSONTyped(value?: FindAllExecutionsAvailableByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FindAllExecutionsAvailableByFacilityId200ResponseDataInnerToJSON)),
    };
}

